import React, { useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import "./App.css";
import moon from "./assets/moon.svg";
import sun from "./assets/sun.svg";
import Social from "./Social";
import Home from "./assets/logoslight/Home.svg";
import HomeDark from "./assets/logosdark/HomeDark.svg";

// global variables
let circle_counter = 0;
let animate_counter = 0;

function App() {
  const [mode, setMode] = useState(true);
  const [flip, setFlip] = useState(false);

  // toggle dark and light mode
  const toggleMode = () => {
    const container = document.querySelector(".container");
    container.classList.toggle("white-mode");
    container.classList.toggle("dark-mode");
    setMode(!mode);
  };

  // creating ripples
  const animateRipples = (e) => {
    circle_counter += 1;
    const container = document.querySelector(".container");
    const ripple = document.createElement("div");
    ripple.classList.add("ripple" + (circle_counter % 3));
    ripple.style.top = e.clientY - 125 + "px";
    ripple.style.left = e.clientX - 125 + "px";
    container.appendChild(ripple);
    setTimeout(() => container.removeChild(ripple), 900);
  };

  // mousemove event handler
  const handleMouseMove = (e) => {
    animate_counter += 1;
    // animating only 10% of the time to reduce the amount of circles on the screen
    if (animate_counter % 10 === 0) {
      animateRipples(e);
    }
  };

  // click event handler
  const handleClick = (e) => {
    animateRipples(e);
  };

  return (
    <>
      <div
        className="container white-mode"
        onMouseMove={!flip ? (e) => handleMouseMove(e) : () => {}}
        onClick={!flip ? (e) => handleClick(e) : () => {}}
      >
        {mode && <img src={moon} alt="" onClick={toggleMode} />}
        {!mode && <img src={sun} alt="" onClick={toggleMode} />}

        {flip ? (
          <Social dark={mode} />
        ) : (
          <div className="content">
            <div className="intro1">Hi! I am</div>
            <div className="name">VIVEK</div>
            <div className="intro2">a half-stack developer</div>
          </div>
        )}
        <div className="contact" onClick={() => setFlip(!flip)}>
          {flip ? <img src={mode ? Home : HomeDark} alt="" /> : <span>@</span>}
        </div>
      </div>
      <Analytics />
    </>
  );
}

export default App;
